var Intesa = Intesa || {};

Intesa.FormValidatorsPbz = function() {
	
	var form = this;
	var isPbz = $("html").attr("data-bank") == "PBZ";
	
	
	this.init = function() {
		if (isPbz) {
			if($("#item_mbs").length > 0 || $("#item_oib").length > 0){
				this.eventErrorManager();
				this.mbsCheck();
				this.oibCheck();
				this.submitCheck();
			}
		}
	}
	
	 this.oibCheck = function () {
		$(".item_oib").on("keyup",function (){
			if($(this).val().length == 11){
				var containerErrors = $(this).attr("data-parsley-errors-container");
				var containerErrorsElement = $(containerErrors);
				var errorMessageValidatorISO = $(this).attr("data-message-validator-formula");
				var value = $(this).val();
				var validator = new MOD11_10();
				console.log(validator.verify(value));
				var check = validator.verify(value).toString();
				console.log("check :",check);
				if (check == "true"){
					window.ParsleyUI.removeError($(this).parsley(), "myCustomError");
					$(this).parent().find("#checkErrorsFormulaOIB").val("false");
				}else{
					var isAlreadyError = containerErrorsElement.find("ul").find(".parsley-myCustomError");
					if(isAlreadyError.length > 0){
						console.log("error exist");
						$(this).parent().find("#checkErrorsFormulaOIB").val("true");
					}else{
						window.ParsleyUI.addError($(this).parsley(), "myCustomError", errorMessageValidatorISO);
						$(this).parent().find("#checkErrorsFormulaOIB").val("true");
					}
				}
			}else{
				$(this).parent().find("#checkErrorsFormulaOIB").val("false");
				$(this).parsley().validate();
			}
			
		});
	}

	 this.mbsCheck = function () {
		$(".item_mbs").on("keyup",function() {
			var errorMessageValidatorFormula = $(this).attr("data-message-validator-formula");
			var containerErrors = $(this).attr("data-parsley-errors-container");
			var containerErrorsElement = $(containerErrors);
			if($(this).val().length == 8){
				var value = $(this).val();
				var result = form.calcArray(value);
				if(result == false){
					var isAlreadyError = containerErrorsElement.find("ul").find(".parsley-myCustomError");
					if(isAlreadyError.length > 0){
						console.log("error exist");
						$(this).parent().find("#checkErrorsFormulaMBS").val("true");
					}else{
						window.ParsleyUI.addError($(this).parsley(), "myCustomError", errorMessageValidatorFormula);
						$(this).parent().find("#checkErrorsFormulaMBS").val("true");
					}
				}else{
					$(this).parent().find("#checkErrorsFormulaMBS").val("false");
					window.ParsleyUI.removeError($(this).parsley(), "myCustomError");
				}
			}else{
				$(this).parent().find("#checkErrorsFormulaMBS").val("false");
				$(this).parsley().validate();
			}
		});

	}

	this.eventErrorManager = function (){
		$(".item_mbs").each(function (){
			$(this).parsley().on('field:validate', function() {
				var errorMessageValidatorFormula = $(this.element).attr("data-message-validator-formula");
				window.ParsleyUI.removeError($(this.element).parsley(), "myCustomError");
			});
		});

		$(".item_oib").each(function (){
			$(this).parsley().on('field:validate', function() {
				var errorMessageValidatorFormula = $(this.element).attr("data-message-validator-formula");
				window.ParsleyUI.removeError($(this.element).parsley(), "myCustomError");
			});
		});
		
		$(".item_mbs").each(function (){
			$(this).parsley().on('field:validated', function() {
				var check = $(this.element).parent().find("#checkErrorsFormulaMBS").val().toString();
				var errorMessageValidatorFormula = $(this.element).attr("data-message-validator-formula");
				if(check == "true"){
					var containerErrors = $(this).attr("data-parsley-errors-container");
					var containerErrorsElement = $(containerErrors);
					var isAlreadyError = containerErrorsElement.find("ul").find(".parsley-myCustomError");
					if(isAlreadyError.length > 0){
						console.log("error exist");
					}else{
						window.ParsleyUI.addError($(this.element).parsley(), "myCustomError",errorMessageValidatorFormula);
					}
				}else{
					window.ParsleyUI.removeError($(this.element).parsley(), "myCustomError");
				}
				
			});
		});

		$(".item_oib").each(function (){
			$(this).parsley().on('field:validated', function() {
				var check = $(this.element).parent().find("#checkErrorsFormulaOIB").val().toString();
				var errorMessageValidatorISO = $(this.element).attr("data-message-validator-formula");
				if(check == "true"){
					var containerErrors = $(this).attr("data-parsley-errors-container");
					var containerErrorsElement = $(containerErrors);
					var isAlreadyError = containerErrorsElement.find("ul").find(".parsley-myCustomError");
					if(isAlreadyError.length > 0){
						console.log("error exist");
					}else{
						window.ParsleyUI.addError($(this.element).parsley(), "myCustomError",errorMessageValidatorISO);
					}
				}else{
					window.ParsleyUI.removeError($(this.element).parsley(), "myCustomError");
				}
			});
		});
			
	}

	this.submitCheck = function(){
		$(".for__form").on("submit",function (event){                
	        event.preventDefault();
			var errorMessageValidatorFormula = $(this).find("#item_mbs").attr("data-message-validator-formula");
			var errorMessageValidatorISO = $(this).find("#item_oib").attr("data-message-validator-formula");
			console.log("sdfsadfsadfdasfasdfasdf");
			var isErrorMBS = $(this).find("#checkErrorsFormulaMBS");
			var isErrorOIB = $(this).find("#checkErrorsFormulaOIB");
			if(isErrorMBS.val() == "true" || isErrorOIB.val() == "true" ){
				if(isErrorMBS.val() == "true" ){
					window.ParsleyUI.addError($($(this).find("#item_mbs")).parsley(), "myCustomError", errorMessageValidatorFormula);
				}
				if(isErrorOIB.val() == "true"){
					window.ParsleyUI.addError($($(this).find("#item_oib")).parsley(), "myCustomError", errorMessageValidatorISO);
				}
	            event.preventDefault();
				return false;
			}else{
	             $(this)[0].submit();
	        }
		});
	}

	this.calcArray = function(array){
		var zzz = 0 ;
		var ost = 0 ;
		var raz = 0 ;
		var cmdNuber ;
		for (var i = 0 ; i < array.length ; i++){
			switch (i){
			case 0:
				cmdNumber = parseInt(array[i]);
				zzz = zzz + (cmdNumber * 8);
				break;
			case 1:
				cmdNumber = parseInt(array[i]);
				zzz =zzz + (cmdNumber * 7);
				break;
			case 2:
				cmdNumber = parseInt(array[i]);
				zzz = zzz + (cmdNumber * 6);
				break;
			case 3:
				cmdNumber = parseInt(array[i]);
				zzz = zzz + (cmdNumber * 5);
				break;
			case 4:
				cmdNumber = parseInt(array[i]);
				zzz = zzz + (cmdNumber * 4);
				break;
			case 5:
				cmdNumber = parseInt(array[i]);
				zzz =zzz + ( cmdNumber * 3);
				break;
			case 6:
				cmdNumber = parseInt(array[i]);
				zzz =zzz + ( cmdNumber * 2);
				break;
			default:
				break;
			}
		}
		ost = zzz%11 ;
		ost = Math.round(ost)
		raz = 11 - ost ;
		if(raz == 10){
			raz = 0;
		}
		if(raz == array[7]){
			console.log("true");
			return true;
		}else{
			console.log("false");
			return false;
		}
		
	}

	
}





Intesa.FormValidatorsPbz.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

    }

	if( !window.intesa.form_validator_pbz ) {

		window.intesa.form_validator_pbz = new Intesa.FormValidatorsPbz();

	}

	return window.intesa.form_validator_pbz;

};
